/* eslint-disable */
const customerConfig =
  require(`./../../clients/${process.env.CLIENT}/config`).default;

export default class options {
  //common
  static authenticatorauthorisationcontroller = {
    subscriptionOptions: customerConfig.subscriptionOptions,
    SSOCookieName: customerConfig.SSOCookieName,
    SSOEnabled: customerConfig.SSOEnabled,
    SSOCookieOptions: customerConfig.SSOCookieOptions,
    deleteSSOCookie: customerConfig.deleteSSOCookie,
    getSSOTokenFromUrl: customerConfig.getSSOTokenFromUrl,
    generateSSOState: customerConfig.generateSSOState,
    paywallRedirectionUrl: customerConfig.paywallRedirectionUrl,
    urlSSOTokenParameter: customerConfig.urlSSOTokenParameter,
    urlRedirectParameter: customerConfig.urlRedirectParameter,
  };

  static useSlider = {
    useSliderForPromospot: customerConfig.useSliderForPromospot,
    useSliderForHorsSeries: customerConfig.useSliderForHorsSeries,
    useSliderForArchive: customerConfig.useSliderForArchive,
  };

  static regionmanager = {
    defaultRegion: customerConfig.defaultRegion,
    defaultDownloadToken: customerConfig.defaultDownloadToken,
    forceRegionCookie: customerConfig.forceRegionCookie,
    forceRegionCookieOptions: customerConfig.forceRegionCookieOptions,
    deleteForceRegionCookie: customerConfig.deleteForceRegionCookie,
    downloadToken: customerConfig.newsStandDownloadToken, //used for par-eco, par-etudiant
  };

  static downloadComponent = {
    paywallRedirectionUrl: customerConfig.paywallRedirectionUrl,
    paywallRedirectionTimeReset: customerConfig.paywallRedirectionTimeReset,
    externalPaywallMaxRedirectionNumber:
      customerConfig.externalPaywallMaxRedirectionNumber,
    generateSSOState: customerConfig.generateSSOState,
    homeRedirectionLink: customerConfig.homeRedirectionLink,
    showBackButtonParam: customerConfig.showBackButtonParam,
    urlRedirectParameter: customerConfig.urlRedirectParameter,
  };

  static sizes = {
    covers: {
      S: customerConfig.namedSizeCoverS,
      M: customerConfig.namedSizeCoverM,
    },
    previews: {
      thumbs: {
        nonNamedSize: customerConfig.sizePreviewS,
        namedSize: customerConfig.namedSizePreviewS,
      },
      nonHD: {
        nonNamedSize: customerConfig.sizePreviewM,
        namedSize: customerConfig.namedSizePreviewM,
      },
      HD: {
        nonNamedSize: customerConfig.sizePreviewL,
        namedSize: customerConfig.namedSizePreviewL,
      },
    },
    images: {
      nonHD: {
        nonNamedSize: customerConfig.sizeImageM,
        namedSize: customerConfig.namedSizeImageM,
      },
      HD: {
        nonNamedSize: customerConfig.sizeImageL,
        namedSize: customerConfig.namedSizeImageL,
      },
    },
  };

  static promospot = {
    onlySupplementsInPromospot: customerConfig.onlySupplementsInPromospot,
  };

  static paywallcomponent = {
    subscription_validate_email: customerConfig.subscription_validate_email,
    noPasswordLogin: customerConfig.noPasswordLogin,
  };

  static about = {
    editor: customerConfig.editor,
    developer: customerConfig.developer,
    openHelpOnNewtab: customerConfig.openHelpOnNewtab,
    hideDisclaimer: customerConfig.hideDisclaimer,
  };
  static settings = {
    subscriptionOptions: customerConfig.subscriptionOptions,
    about: options.about,
    displayViewerOptions: customerConfig.displayViewerOptions,
    turnOnSettings: customerConfig.turnOnSettings,
    useCustomTooltips: customerConfig.useCustomTooltips,
    displayTopNavButtonlabel: customerConfig.displayTopNavButtonlabel,
    voucher: customerConfig.voucher,
    replicaReadingModeToggle: customerConfig.replicaReadingModeToggle,
    toggleSubscriptionTopNavButtonOnUserLoggedIn:
      customerConfig.toggleSubscriptionTopNavButtonOnUserLoggedIn,
    paywallRedirectionUrl: customerConfig.paywallRedirectionUrl,
    paywallRedirectionTimeReset: customerConfig.paywallRedirectionTimeReset,
    externalPaywallMaxRedirectionNumber:
      customerConfig.externalPaywallMaxRedirectionNumber,
    generateSSOState: customerConfig.generateSSOState,
    urlRedirectParameter: customerConfig.urlRedirectParameter,
    openHelpOnNewtab: customerConfig.openHelpOnNewtab,
    openPrivacyOnNewtab: customerConfig.openPrivacyOnNewtab,
    showPrivacyPolicy: customerConfig.showPrivacyPolicy,
  };

  static help = {
    turnOnHeaderHelp: customerConfig.turnOnHeaderHelp,
  };
  static sidemenuswiper = {
    numberOfSlidesVisible: customerConfig.numberOfSlidesVisibleSideMenu,
    spaceBetweenSlides: customerConfig.spaceBetweenSlidesSideMenu,
  };
  static sidemenu = {
    sidemenuThema: customerConfig.sidemenuThema,
    extraInfo: customerConfig.extraInfo,
    sidemenuswiper: options.sidemenuswiper,
    settings: options.settings,
    recentlyLength: customerConfig.recentlyLength,
    homeRedirectionLink: customerConfig.homeRedirectionLink,
    sidemenuWidth: customerConfig.sidemenuWidth,
    sidemenuAnimationDuration: customerConfig.sidemenuAnimationDuration,
    displayViewerOptions: customerConfig.displayViewerOptions,
    logoRedirect: customerConfig.logoRedirect,
  };

  //home
  static swiper = {
    numberOfSlidesVisible: customerConfig.numberOfSlidesVisible,
    spaceBetweenSlides: customerConfig.spaceBetweenSlides,
  };

  static kiosque = {
    usePromoSpot: customerConfig.usePromoSpot,
    customKiosqueTitle: customerConfig.customKiosqueTitle,
    topNavButtonLabel: customerConfig.topNavButtonLabel,
    topNavButtonHasFunction:
      customerConfig.topNavButtonHasFunction /* this config is enaled if a function is called when the top nav button is clicked and not a redirection url*/,
    topNavBtnCookieConsent:
      customerConfig.topNavBtnCookieConsent /*this config is enabled if the cookie consent used the top nav button to show the cookie setting screen (cfr dum)*/,
    displayArchive: customerConfig.displayArchive,
    displayHorsSerieArchive: customerConfig.displayHorsSerieArchive,
    swiper: options.swiper,
    archiveLength: customerConfig.archiveLength,
    sizes: options.sizes.covers,
    displayViewerOptions: customerConfig.displayViewerOptions,
    useSlider: options.useSlider,
    toggleSubscriptionTopNavButtonOnUserLoggedIn:
      customerConfig.toggleSubscriptionTopNavButtonOnUserLoggedIn,
    homeRelativeDepth: customerConfig.homeRelativeDepth,
    showPreviewPublications: customerConfig.showPreviewPublications,
  };
  //reader
  static slidernavigation = {
    thumbsNavigation: customerConfig.thumbsNavigation,
    sizes: options.sizes.previews.thumbs,
  };

  static pdfPage = {
    pdfThreshold: customerConfig.pdfThreshold,
    pdfThresholdTouch: customerConfig.pdfThresholdTouch,
    pdfLoadingTimeout: customerConfig.pdfLoadingTimeout,
    pdfCleanupDelta: customerConfig.pdfCleanupDelta,
  };

  static readerPage = {
    normal_size: customerConfig.normal_size,
    hd_size: customerConfig.hd_size,
    sizes: options.sizes.previews,
    page_width_reference: customerConfig.page_width_reference,
    page_height_reference: customerConfig.page_height_reference,
    enrichment_placement_vertical: customerConfig.enrichment_placement_vertical,
    enrichment_placement_horizontal:
      customerConfig.enrichment_placement_horizontal,
    pdfPage: options.pdfPage,
    /*if article only contains an enrichment link then add the link to the clickable area so that when clicked we directly open
    the link in a new window*/
    extraLinkDirectAccess: customerConfig.extraLinkDirectAccess,
  };

  static hammerslide = {
    max_zoom: customerConfig.max_zoom,
    pinchPanTimeInterval: customerConfig.pinchPanTimeInterval,
    pinchTreshold: customerConfig.pinchTreshold,
    activeAreaPercentage: customerConfig.activeAreaPercentage,
  };

  static readerSlide = {
    readerPage: options.readerPage,
    hammerslide: options.hammerslide,
  };
  static reader = {
    useFullWidthLandscapeSinglePage:
      customerConfig.useFullWidthLandscapeSinglePage,
    useFullWidthLandscapeDoublePage:
      customerConfig.useFullWidthLandscapeDoublePage,
    preloadingHdPages: customerConfig.preloadingHdPages,
    readerSlide: options.readerSlide,
    touchDownloadPdf: customerConfig.touchDownloadPdf,
    fullPdfDownloadOnly: customerConfig.fullPdfDownloadOnly,
    allowFullPdfDownload: customerConfig.allowFullPdfDownload,
    enableTopNavDropdown: customerConfig.enableTopNavDropdown,
  };

  static imageviewerslide = {
    imageViewerCaptionOnlyFirstLines:
      customerConfig.imageViewerCaptionOnlyFirstLines,
    hammerslide: options.hammerslide,
    sizes: options.sizes.images,
  };
  static imageviewer = {
    imageviewerKeepScale: customerConfig.imageviewerKeepScale,
    imageviewerslide: options.imageviewerslide,
  };
  static albslide = {
    fixedImgHeight: customerConfig.fixedImgHeight,
    captionMaxLines: customerConfig.captionMaxLines,
    extraButtonInTitle: customerConfig.extraButtonInTitle,
    hideExtraButtonWhenInExtras: customerConfig.hideExtraButtonWhenInExtras,
    extraButtonOnSlider: customerConfig.extraButtonOnSlider,
    fullWidthImage: customerConfig.fullWidthImage,
    extraButtonOnEachPage: customerConfig.extraButtonOnEachPage,
    marginScrollExtraInView: customerConfig.marginScrollExtraInView,
    extrasInViewMargin: customerConfig.extrasInViewMargin,
    imageviewer: options.imageviewer,
    sizes: options.sizes.images,
    displayPageCategory: customerConfig.displayPageCategory,
  };

  static fontSizeService = {
    maxfontSize: customerConfig.maxfontSize,
    fontSizeStep: customerConfig.fontSizeStep,
    rootFontSize: customerConfig.rootFontSize,
  };

  static sharing = {
    printArticle: customerConfig.printArticle,
    shareFromReader: customerConfig.shareFromReader,
    shareFromNextgen: customerConfig.shareFromNextgen,
    sharingOptions: customerConfig.sharingOptions,
    printSize: customerConfig.printImageSize,
    printExtraMargin: customerConfig.printExtraMargin,
    printPadding: customerConfig.printPadding,
    printMarginLeft: customerConfig.printMarginLeft,
  };

  static albcontroller = {
    extraButtonOnSlider: customerConfig.extraButtonOnSlider,
    increaseFontSizeEnabled: customerConfig.increaseFontSizeEnabled,
    albSlideOnlyOnePage: customerConfig.albSlideOnlyOnePage,
    sharingEnabled: customerConfig.sharingEnabled,
    albslide: options.albslide,
    fontSizeService: options.fontSizeService,
    sharing: options.sharing,
    printArticle: customerConfig.printArticle,
    shareFromReader: customerConfig.shareFromReader,
  };

  static cookie = {
    cookie_info_cookie_name: customerConfig.cookie_info_cookie_name,
    cookieEnabled: customerConfig.cookieEnabled,
    disableCookieSameSitePolicy: customerConfig.disableCookieSameSitePolicy,
  };

  static contentPackageStore = {
    useNameAsLabel: customerConfig.useNameAsLabel,
    downloadToken: customerConfig.newsStandDownloadToken, //used for par-eco, par-etudiant
  };

  static horsserieStore = {
    useHSNameAsLabel: customerConfig.useHSNameAsLabel,
  };

  static pubStore = {
    pageWidth: customerConfig.page_width_reference,
    pageHeight: customerConfig.page_height_reference,
    activePageArea:
      customerConfig.page_width_reference *
      customerConfig.page_height_reference *
      customerConfig.activeAreaPercentage,
    dropCapIfFirstBold: customerConfig.dropCapIfFirstBold,
    sizes: options.sizes.covers,
    page_ratio: customerConfig.page_ratio,
    replicaImageSize: options.reader.readerSlide.readerPage.hd_size,
  };

  static cpStore = {
    shareFromReader: customerConfig.shareFromReader,
    shareFromNextgen: customerConfig.shareFromNextgen,
    channel: customerConfig.channel,
    product_name_for_engage_readers:
      customerConfig.product_name_for_engage_readers,
    sizes: options.sizes.covers,
  };

  static print = {
    imageSize: customerConfig.printImageSize,
    printCroppedPdf: customerConfig.printCroppedPdf,
  };

  static desktopReader = {
    readerEnableHorsseries: customerConfig.readerEnableHorsseries,
    toggleSubscriptionTopNavButtonOnUserLoggedIn:
      customerConfig.toggleSubscriptionTopNavButtonOnUserLoggedIn,
  };

  static zoom = {
    desktopMaxZoom: customerConfig.desktopMaxZoom,
    zoomSteps: customerConfig.zoomSteps,
  };

  static usePdf = {
    usePdfPhone: customerConfig.usePdfPhone,
    usePdfPhoneNot: customerConfig.usePdfPhoneNot,
    usePdfTablet: customerConfig.usePdfTablet,
    usePdfTabletNot: customerConfig.usePdfTabletNot,
    usePdfDesktop: customerConfig.usePdfDesktop,
    usePdfDesktopNot: customerConfig.usePdfDesktopNot,
  };

  static nextgen = {
    redirectUrl: customerConfig.homeRedirectionLink,
  };

  static analytics = {
    showBackButtonParam: customerConfig.showBackButtonParam,
  };

  static app = {
    useCookiePostfix: customerConfig.useCookiePostfix,
    //common
    regionmanager: options.regionmanager,
    authenticatorauthorisationcontroller:
      options.authenticatorauthorisationcontroller,
    sidemenu: options.sidemenu,
    defaultPreferredViewer: customerConfig.defaultPreferredViewer,
    //home
    kiosque: options.kiosque,
    //reader
    channel: customerConfig.channel,
    replicaReadingModeToggle: customerConfig.replicaReadingModeToggle,
    replicaReadingModeDefault: customerConfig.replicaReadingModeDefault, //double page is default
    reader: options.reader,
    slidernavigation: options.slidernavigation,
    albcontroller: options.albcontroller,
    cookie: options.cookie,
    pubStore: options.pubStore,
    cpStore: options.cpStore,
    sizes: options.sizes,
    dateFormat: customerConfig.dateFormat,
    promospot: options.promospot,
    newsstandRedirecting: customerConfig.newsstandRedirecting,
    print: options.print,
    desktopReader: options.desktopReader,
    settings: options.settings,
    help: options.help,
    usePdf: options.usePdf,
    zoom: options.zoom,
    homeRedirectionLink: customerConfig.homeRedirectionLink,
    homeRedirectionLinkUAT: customerConfig.homeRedirectionLinkUAT,
    homeRedirectionLinkPROD: customerConfig.homeRedirectionLinkPROD,
    logo404: customerConfig.logo404,
    activePageArea: customerConfig.activeAreaPercentage,
    pdfPage: options.pdfPage,
    socialSharingHash: customerConfig.socialSharingHash,
    allowNextgenPageSharing: customerConfig.allowNextgenPageSharing,
    nextgen: options.nextgen,
    imageviewer: options.imageviewer,
    displayViewerOptions: customerConfig.displayViewerOptions,
    useCustomTooltips: customerConfig.useCustomTooltips,
    displayTopNavButtonlabel: customerConfig.displayTopNavButtonlabel,
    toggleSubscriptionTopNavButtonOnUserLoggedIn:
      customerConfig.toggleSubscriptionTopNavButtonOnUserLoggedIn, //When the user is logged in, we hide the se connecter button as well as the other top nav button.
    logoRedirect: customerConfig.logoRedirect,
    contentPackageStore: options.contentPackageStore,
    horsserie: options.horsserieStore,
    downloadComponent: options.downloadComponent,
    sharing: options.sharing,
    paywallcomponent: options.paywallcomponent,
    cmpScript: customerConfig.cmpScript,
    enableCookieConsent: customerConfig.enableCookieConsent,
    showBackButtonParam: customerConfig.showBackButtonParam,
    hasConsentScript: customerConfig.hasConsentScript,
    displayPublicationNameInSidebar:
      customerConfig.displayPublicationNameInSidebar,
    featuresToBeEnabledByBE: customerConfig.featuresToBeEnabledByBE,
    singlePageDisplayedProportion: customerConfig.singlePageDisplayedProportion,
    redirectReaderFromIframe: customerConfig.redirectReaderFromIframe,
    returnToIframeUrl: customerConfig.returnToIframeUrl,
  };
}



// WEBPACK FOOTER //
// ./src/common/config.js